import type { ReactNode } from 'react'
import { useNavigate, useLocation } from 'react-router'
import { useEffect } from 'react'
import { useAuth } from '@klear/ui/contexts/auth-context'

interface PermissionGuardProps {
  children: ReactNode
  entity: string
  action: string
}

const PermissionGuard = ({ children, entity, action }: PermissionGuardProps) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useAuth()

  useEffect(() => {
    if (!user?.hasPermission(entity, action)) {
      console.debug('Unauthorized')
      navigate('/unauthorized', {
        state: { from: location },
        replace: true
      })
    }
  }, [navigate, location, user])

  return <>{children}</>
}

export default PermissionGuard
